import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Container, Row, Col } from "reactstrap";
import UploadModal from "./uploadModal";
import "./style.scss";
import InterActiveModeService from "services/Admin/InterActiveModeService";
import Paginator from "components/Common/Paginator/Paginator";
import { useDispatch, useSelector } from "react-redux";
import { appendData } from "store/Mode/actions";

const InteractiveMode = (props) => {
	const dispatch = useDispatch();
	const interActiveModeService = new InterActiveModeService();
	const [filtersParams, setFilterParams] = useState(null);
	const [searchWord, setSearchWord] = useState("");
	const [list, setList] = useState([]);
	const [editMode, setEditMode] = useState(null);
	const [modal, setModal] = useState(false);
	const [deleteInteractive, setDeleteInteractive] = useState(null);
	const [shouldGetData, setShouldGetData] = useState(false);
	const [compoundOptions, setCompoundOptions] = useState([]);
	const [updateUptions, setUpdateOptions] = useState(true);
	const AuthData = useSelector((state) => state.Auth);
	const isExist = (data) =>
		AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com";
	const toggle = () => setModal(!modal);
	const [pageOptions, setPageOptions] = useState({
		sizePerPage: 10,
		totalSize: 1,
	});

	useEffect(() => {
		if (!modal) {
			setEditMode(null);
		}
	}, [modal]);

	useEffect(() => {
		dispatch(
			appendData({
				type: "add",
				editId: "",
				compound: null,
				currentImge: null,
				constrains: null,
				images: [],
				previousImg: null,
				masterImg: null,
			})
		);
	}, []);

	useEffect(() => {
		if (!deleteInteractive) {
			setDeleteInteractive(null);
		}
	}, [deleteInteractive]);

	useEffect(() => {
		// debounce solution to reduce request data from api
		const timeoutId = setTimeout(() => {
			const params = {};
			if (searchWord.trim().length) params["keyword"] = searchWord;
			setFilterParams({ ...params });
		}, 1000);
		return () => clearTimeout(timeoutId);
	}, [searchWord]);

	const OnSearchChange = (e) => {
		const search = e.target.value;
		setSearchWord(search);
	};

	useEffect(() => {
		if (updateUptions) {
			interActiveModeService.getCompoundsInteractives().then((res) => {
				const newOptions = res.data.map((item) => {
					return {
						label: item.name.en,
						value: item.id,
						images: item.images,
					};
				});
				setCompoundOptions(newOptions);
			});
			setUpdateOptions(false);
		}
	}, [updateUptions]);

	return (
		<React.Fragment>
			<div className="page-content mode-page">
				<MetaTags>
					<title>interactive mode</title>
				</MetaTags>
				<Container fluid>
					<Row className="mb-1">
						<Col md={6}>
							<h4>Manage Interactive Mode</h4>
						</Col>
					</Row>
					<Row className="mb-4">
						<Col md={6}>
							<div className="form-group has-search">
								<span className="fa fa-search form-control-feedback"></span>
								<input
									type="text"
									className="form-control"
									placeholder="Search by Compound Name, I.D"
									onChange={(e) => OnSearchChange(e)}
									value={searchWord}
								/>
							</div>
						</Col>
						{isExist("interactive.add") ? (
							<Col md={6}>
								<div className="d-md-flex justify-content-md-end mb-2">
									<button
										className="btn btn-success btnHeight px-lg-4"
										onClick={() => setModal(true)}
										// disabled={compoundOptions.length === 0 ? true : false}
									>
										Add New Interactive mode
									</button>
								</div>
							</Col>
						) : null}
					</Row>
					<Row style={{ background: "white" }} className="px-2 py-4 mx-1">
						{list.map((item, index) => {
							return (
								<Col
									key={index}
									md={3}
									style={{ position: "relative" }}
									className="mb-2"
									onClick={() => {
										if (
											isExist("interactive.edit") ||
											isExist("interactive.delete")
										) {
											setEditMode(item);
											setModal(true);
										}
									}}>
									<div className="position-relative">
										<img
											src={item?.main_image?.path}
											style={{
												height: "120px",
												width: "100%",
												borderRadius: "10px",
											}}
										/>
										{item?.draft && (
											<span
												style={{
													position: "absolute",
													top: "8px",
													left: "8px",
													background: "#FFC007",
													borderRadius: "8px",
													padding: "4px 8px",
													fontWeight: "500",
												}}>
												Pending
											</span>
										)}
									</div>
									<p className="fw-bold mt-2 font-size-16 fw-bolder mb-0">
										{item?.compound?.name?.en}
									</p>
									<p className="font-size-12 text-muted">
										{item?.hotspots} Hotspots
									</p>
								</Col>
							);
						})}
					</Row>
					{modal && (
						<UploadModal
							toggle={toggle}
							modal={modal}
							history={props.history}
							editMode={editMode}
							from="interactive"
							setShouldGetData={setShouldGetData}
							compoundOptions={compoundOptions}
							setCompoundOptions={setCompoundOptions}
							setUpdateOptions={setUpdateOptions}
						/>
					)}
					<Row>
						<Col
							className="d-flex justify-content-between mt-3 w-100"
							md={12}
							sm={12}>
							<Paginator
								service={interActiveModeService}
								pageOptions={pageOptions}
								setData={(data) => setList([...data])}
								setPageOptions={setPageOptions}
								filtersParams={filtersParams}
								shouldGetData={shouldGetData}
								setShouldGetData={setShouldGetData}
							/>
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default InteractiveMode;
